<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
========================================================================================== -->
<template>
  <AuthContainer>
    <div class="p-8 login-tabs-container">
      <div class="vx-card__title mb-6">
        <h3 class="mb-3 mt-2">Visitor Manager</h3>
        <p>Welcome back, please login to your account.</p>
      </div>
      
      <form @submit.prevent="loginSubmit">
        <input type="submit" class="hidden" />
        <vs-input
          name="email"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label-placeholder="Email"
          v-model="email"
          class="w-full"
          v-validate="'required|email'"
          data-vv-validate-on="blur"
        />
        <span class="block text-danger text-sm mt-1" v-if="errors.has('email')">{{ errors.first('email') }}</span>

        <vs-input
          type="password"
          name="password"
          icon-no-border
          icon="icon icon-lock"
          icon-pack="feather"
          label-placeholder="Password"
          class="w-full mt-6"
          v-model="password"
          v-validate="'required'"
          data-vv-validate-on="blur"
        />
        <span class="block text-danger text-sm mt-1" v-if="errors.has('password')">{{ errors.first('password') }}</span>

        <vs-alert color="danger" v-if="message" class="mt-1">
          <p class="text-xs">{{ message }}</p>
        </vs-alert>

        <div class="flex flex-wrap justify-between my-4">
          <vs-checkbox v-model="checkbox_remember_me" class="mb-1">Remember Me</vs-checkbox>
          <router-link to="/forgotpassword">Forgot Password?</router-link>
        </div>

        <vs-button @click="loginSubmit">Login</vs-button>

        <p class="text-center mt-6 mb-1">
          Want Contactless Visitor Management for your business?
          <router-link to="signup">Sign up here</router-link>
        </p>
      </form>

    </div>
      <template v-slot:footer>
   <div class="py-3 text-center"> <p>Looking for Time & Attendence solutions? Visit us at <a href="https://jointimecloud.com/" target="_blank" rel="nofollow">jointimecloud.com</a></p></div>
  </template>
  </AuthContainer>
</template>

<script>
import AuthContainer from '@/views/pages/components/AuthContainer.ts.vue';
import { mapState, mapGetters } from 'vuex';
import auth0 from '@/auth0';

export default {
  components: {
    AuthContainer
  },
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      message: '',
      tenantId: null
    } 
  },
  computed: {
    ...mapState('auth', {
      tenants: state => {
        return (state.tenants || []).map(item => ({
          value: item.id,
          text: item.companyName
            ? item.companyName
            : (item.firstName && item.lastName)
              ? `${item.firstName} ${item.lastName}`
              : item.email || item.firstName
        }))
      }
    }),
    ...mapGetters('auth', ['isLoggedin', 'tenantSelected']),
    selectTenantVisibility () {
      if (!this.isLoggedin) return true;
      return this.tenantSelected;
    }
  },
  methods: {
    async loginSubmit () {
      const me = this;
      return await this.$validator.validateAll().then(valid => {
        if (valid) {
          auth0.login(me.email, me.password).catch(e => {
            me.message = e.error_description;
          });
        }
      });
    },
    async tenant () {
      return await this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store.dispatch('auth/tenant', { id: this.tenantId }).then(tenant => {
            if (tenant) this.$router.push(this.$route.query.redirect || '/')
          })
        }
      })
    }
  },
  async beforeCreate () {
    await this.$auth0.handleAuthentication()
      .then(() => {
      // if (this.selectTenantVisibility)
        const query = this.$route.query || {};
        this.$router.push((query || {}).redirect || '/').catch(() => {});
      })
      .catch(e => {
        if (e.error === 'unauthorized') return this.$router.push('/unauthorised').catch(() => {});
        if (e.error !== 'login_required') {
          me.message = e.error_description;
        }
      });
  }
}
</script>

<style lang="scss">

</style>
